import { StatisticUnit } from "./types";
import { findKey, lowerCase } from "lodash";

export const getUnitName = (unit: StatisticUnit) =>
  lowerCase(findKey(StatisticUnit, o => o === unit));
